import { useQuery } from '@tanstack/react-query';
import { fetchConfigOptions } from '../services/smr-admin';
import type { ConfigOptionListParams } from '../services/smr-admin';

export const configOptionKeys = {
    all: ['smr-admin', 'config-options'] as const,
    lists: () => [...configOptionKeys.all, 'list'] as const,
    list: (params: ConfigOptionListParams) => [...configOptionKeys.lists(), params] as const,
    detail: (id: string) => [...configOptionKeys.all, 'detail', id] as const,
};

export const useConfigOptionsQuery = (params: ConfigOptionListParams = {}) =>
    useQuery({
        queryKey: configOptionKeys.list(params),
        queryFn: () => fetchConfigOptions(params),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
